import React, { PureComponent } from 'react'
import { Spin, Button, Modal, Table, Row, Col, Input } from 'antd'
import moment from 'moment'
import { TicketOrderList } from '_src/api/api'
import './style.less'

const { Search } = Input
class Order extends PureComponent {
  constructor() {
    super()
    this.state = {
      isLoading: true,
      params: {
        pageNum: 0,
        pageSize: 10,
      },
      pageData: {
        total: 0,
        current: 1,
      },
      columns: [
        {
          title: <span>渠道</span>,
          align: 'center',
          dataIndex: 'channel',
        },
        {
          title: <span>单号</span>,
          align: 'center',
          render: (item) => <div>
            <div>订单号：{item.orderSn}</div>
            {item.paySn ? <div>支付单号：{item.paySn}</div> : ''}
            {item.transactionSn ? <div>交易单号：{item.transactionSn}</div> : ''}
          </div>,
        },
        {
          title: <span>时间</span>,
          align: 'center',
          dataIndex: 'payAt',
        },
        {
          title: <span>订单信息</span>,
          align: 'center',
          render: (item) => <div>
            <div>线路：{item.line}</div>
            <div>班次：{item.shiftCode}</div>
          </div>,
        },
        {
          title: <span>总金额</span>,
          align: 'center',
          dataIndex: 'realMoney',
        },
        {
          title: <span>姓名</span>,
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: <span>手机号码</span>,
          align: 'center',
          dataIndex: 'mobile',
        },
        {
          title: <span>状态</span>,
          align: 'center',
          dataIndex: 'orderStatus',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <div>
            <Button icon="form" onClick={() => { this.onEdit(item.id) }} style={{ marginRight: 10 }}>详情</Button>
          </div>,
        },
      ]
    }
  }
  componentDidMount() {
    const { params } = this.state
    this.loadList(params)
  }

  loadList(params) {
    TicketOrderList(params).then( res => {
      if(res && res.data) {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      }
    }).catch( err => {
      this.setState({
        list: [],
        isLoading: false,
        pageData: {
          current: 0,
          total: 0,
          pageSize: 0,
        },
      })
    })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 通用切换事件
  commonChange = (e, key) => {
    const { params } = this.state
    params.pageNum = 0
    if (e) {
      params[key] = e
    } else {
      delete params[key]
    }
    this.setState({params})
    this.loadList(params)
  }

  // 查看详情
  onEdit = (id) => {
    
  }
  
  render() {
    const { isLoading, columns, list, pageData } = this.state
    return (
      <div className="push-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-header'>
          <Row>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >订单号：</span>
              <Search style={{ width: 200 }} placeholder="手机号码" onSearch={(e)=>this.commonChange(e, 'orderSn')} enterButton />
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >姓名：</span>
              <Search style={{ width: 200 }} placeholder="收货人姓名" onSearch={(e)=>this.commonChange(e, 'name')} enterButton />
            </Col>
            <Col lg={{ span: 8 }} style={{ width: 300, marginBottom: 20 }} className="flex-h-a">
              <span >手机号码：</span>
              <Search style={{ width: 200 }} placeholder="手机号码" onSearch={(e)=>this.commonChange(e, 'mobile')} enterButton />
            </Col>
          </Row>
        </div>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
      </div>
    )
  }
}

export default Order